/*
 * Corporate gifting landing page (MER-252).
 * Loaded only on the "corporate-gifting" page template (snippets/rm-custom-gift-head.liquid).
 *
 * 1. Quote CTAs (a[data-rmg-cta]) already carry ?product=<key>&from=<section> from Liquid.
 *    This script appends any utm_* params on this page's URL so the Forge quote form can
 *    save the source.
 * 2. "Add to inquiry" (prototype .add-gift): toggles a gift family in the visitor's inquiry
 *    (label "Added to inquiry", ＋ → ✓, aria-pressed), updates the quote card's
 *    "N product categories in your inquiry: …" line and the mobile bar's count, as in the
 *    prototype. Generic CTAs (no product of their own) then carry one product=<key> per
 *    picked family, in the order picked (the first one is the Forge form's main product).
 * 3. CTA-click event: published through Shopify's Customer Events API
 *    (Shopify.analytics.publish) as rm_gift_quote_cta_click, like the hospitality page's
 *    rm_hosp_quote_cta_click. A custom pixel forwards it to GA4 / other tools.
 * 4. Mobile menu toggle (prototype #menu-toggle): aria-expanded, Open/Close label, closes
 *    when a link is tapped.
 */
(function () {
  'use strict';

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var EVENT_NAME = 'rm_gift_quote_cta_click';
  var picked = []; /* [{ name, key }] in the order picked */

  function readUtms() {
    var out = [];
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      return out;
    }
    UTM_KEYS.forEach(function (key) {
      var value = params.get(key);
      if (value) out.push([key, value.slice(0, 200)]);
    });
    return out;
  }

  /* Rebuild every CTA href from the Liquid-rendered base: product(s), from, then utm_*. */
  function decorateCtas() {
    var utms = readUtms();
    var links = document.querySelectorAll('a[data-rmg-cta]');
    Array.prototype.forEach.call(links, function (link) {
      if (!link.hasAttribute('data-rmg-base-href')) link.setAttribute('data-rmg-base-href', link.getAttribute('href'));
      try {
        var url = new URL(link.getAttribute('data-rmg-base-href'), window.location.href);
        var own = link.getAttribute('data-rmg-product');
        var params = new URLSearchParams();
        if (own) {
          params.append('product', own);
        } else {
          picked.forEach(function (p) { if (p.key) params.append('product', p.key); });
        }
        url.searchParams.forEach(function (value, key) {
          if (key !== 'product') params.append(key, value);
        });
        utms.forEach(function (pair) {
          if (!params.has(pair[0])) params.set(pair[0], pair[1]);
        });
        url.search = params.toString();
        link.setAttribute('href', url.toString());
      } catch (e) {
        /* leave the link as rendered */
      }
    });
  }

  function fill(template, count) {
    return (template || '').replace('[count]', String(count));
  }

  function refreshSelection() {
    var names = picked.map(function (p) { return p.name; });
    var line = document.querySelector('[data-rmg-selected-line]');
    if (line) {
      line.textContent = '';
      if (!names.length) {
        line.textContent = line.getAttribute('data-empty') || '';
      } else {
        var lead = document.createElement('span');
        lead.textContent = names.length === 1 ? line.getAttribute('data-one') : fill(line.getAttribute('data-many'), names.length);
        line.appendChild(lead);
        line.appendChild(document.createTextNode(names.join(', ')));
      }
    }
    var count = document.querySelector('[data-rmg-mobile-count]');
    if (count) {
      count.textContent = !names.length
        ? count.getAttribute('data-default')
        : names.length === 1 ? count.getAttribute('data-one') : fill(count.getAttribute('data-many'), names.length);
    }
    decorateCtas();
  }

  function bindAddButtons() {
    var buttons = document.querySelectorAll('[data-rmg-add-gift]');
    Array.prototype.forEach.call(buttons, function (btn) {
      if (btn.getAttribute('data-rmg-bound')) return;
      btn.setAttribute('data-rmg-bound', '1');
      btn.addEventListener('click', function () {
        var name = btn.getAttribute('data-product');
        var key = btn.getAttribute('data-product-key');
        var at = -1;
        picked.forEach(function (p, i) { if (p.name === name) at = i; });
        if (at > -1) picked.splice(at, 1); else picked.push({ name: name, key: key });
        var chosen = at === -1;
        btn.classList.toggle('is-selected', chosen);
        btn.setAttribute('aria-pressed', chosen ? 'true' : 'false');
        var label = btn.querySelector('.rmg-add-label');
        if (label) label.textContent = chosen ? btn.getAttribute('data-label-added') : btn.getAttribute('data-label-add');
        if (btn.lastElementChild) btn.lastElementChild.textContent = chosen ? '✓' : '＋';
        refreshSelection();
      });
    });
  }

  function trackClicks() {
    document.addEventListener('click', function (event) {
      var target = event.target;
      var link = target && target.closest ? target.closest('a[data-rmg-cta]') : null;
      if (!link) return;
      try {
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          var utms = {};
          readUtms().forEach(function (pair) { utms[pair[0]] = pair[1]; });
          var products = [];
          try {
            products = new URL(link.href).searchParams.getAll('product');
          } catch (e) { /* ignore */ }
          Shopify.analytics.publish(EVENT_NAME, {
            product: products[0] || '',
            products: products,
            from: link.getAttribute('data-rmg-from') || '',
            href: link.href,
            page: window.location.pathname,
            utm: utms
          });
        }
      } catch (e) {
        /* analytics must never block navigation */
      }
    });
  }

  function navToggle() {
    var toggle = document.querySelector('[data-rmg-nav-toggle]');
    var links = document.querySelector('[data-rmg-nav-links]');
    if (!toggle || !links || toggle.getAttribute('data-rmg-bound')) return;
    toggle.setAttribute('data-rmg-bound', '1');
    function set(open) {
      links.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', toggle.getAttribute(open ? 'data-label-close' : 'data-label-open') || '');
    }
    toggle.addEventListener('click', function () {
      set(!links.classList.contains('is-open'));
    });
    Array.prototype.forEach.call(links.querySelectorAll('a'), function (a) {
      a.addEventListener('click', function () { set(false); });
    });
  }

  function init() {
    navToggle();
    bindAddButtons();
    refreshSelection();
  }

  trackClicks();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor: re-run when a section is added/re-rendered. */
  document.addEventListener('shopify:section:load', init);
})();
